import { useState } from 'react';
import { identity } from 'lodash-es';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import { useLinkedField } from './useLinkedField';

import styles from './index.module.css';

const TokenSettings = ({
  actions = [],
  linkedField,
  isOpen = false,
  setIsOpen,
  settingsConfig: {
    icon = 'icons/general/state/settings',
    size = 'm',
    paddings = 's xs',
    customCb = identity
  } = {}
}) => {
  const shouldUseExternalState = Boolean(setIsOpen);
  const [isActive, setIsActive] = useState(isOpen);

  const toggleSettings = () => {
    if (shouldUseExternalState) {
      setIsOpen(!isOpen);
    } else {
      setIsActive(!isActive);
    }
    customCb();
  };

  const isTokenSettingsOpen = shouldUseExternalState ? isOpen : isActive;

  const linkedFieldConfig = useLinkedField(linkedField);

  return (
    <Box align="start">
      {isTokenSettingsOpen ? (
        actions.map(({ actionType, cb, padding = 's' }) => {
          const closeCb = () => {
            if (cb) {
              cb(linkedFieldConfig);
            }
            toggleSettings();
          };
          const callback = actionType === 'close' ? closeCb : cb;
          const handleClick = () => callback(linkedFieldConfig);
          return (
            <Box key={`${actionType}-action`} padding={padding}>
              <Icon
                className={styles.icon}
                name={`icons/general/action/${actionType}`}
                size="l"
                color="accent_color_2"
                onClick={handleClick}
              />
            </Box>
          );
        })
      ) : (
        <Box padding={paddings}>
          <Icon
            className={styles.icon}
            name={icon}
            size={size}
            color="accent_color_2"
            onClick={toggleSettings}
          />
        </Box>
      )}
    </Box>
  );
};

export default TokenSettings;
